<template lang="pug">
  .checkbox-container.column.center
    input.hide(type='checkbox' :id='`checkbox-${index}`')
    label.inner-container(
      :for='`checkbox-${index}`'
      @click='setState'
      :class='`${item.status ? "active" : "inactive"}`'
    )
      simple-svg.icon.row.middle.center(
        :filepath='item.icon'
        :height='"20px"'
        :class='`${item.status ? "white-stroke-icon" : "blue-stroke-icon"}`'
      )
    span.text-center
      | {{ $t(`${item.text}`) }}
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    setState() {
      this.$emit('setFeedbackStatus', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';

.checkbox-container {
  min-height: 90px;
  min-width: 80px;

  &:not(:last-child) {
    margin-right: 25px;
  }
}

.hide {
  visibility: hidden;
}

.inner-container {
  border: 2px solid $blue;
  border-radius: 100%;
  height: 50px;
  margin-bottom: 10px;
  width: 50px;
}

.icon {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
}

.active {
  background-color: $blue;
}
</style>
